import { useState } from 'react';

import clamp from '../../../helpers/number/clamp';
import DetailLevel from '../types/DetailLevel';

const orderedLevels: Array<DetailLevel> = ['day', 'month', 'year'] as const;

type Props = {
    defaultDetailLevel?: DetailLevel;
    maxDetailLevel?: DetailLevel;
    minDetailLevel?: DetailLevel;
};

const useDetailLevel = ({
    maxDetailLevel = 'day',
    minDetailLevel = 'year',
    defaultDetailLevel = 'day',
}: Props) => {
    const [currentLevelIndex, setCurrentLevelIndex] = useState(
        orderedLevels.indexOf(defaultDetailLevel)
    );
    const minIndex = orderedLevels.indexOf(maxDetailLevel);
    const maxIndex = orderedLevels.indexOf(minDetailLevel);

    const moveDetailLevel = (direction: 1 | -1) => {
        const nextIndex = currentLevelIndex + direction;
        if (nextIndex < 0 || nextIndex >= orderedLevels.length) {
            return undefined;
        }

        return setCurrentLevelIndex(nextIndex);
    };

    const showMoreDetails = () => moveDetailLevel(-1);
    const showLessDetails = () => moveDetailLevel(1);
    const clampedIndex = clamp(currentLevelIndex, minIndex, maxIndex);

    return {
        currentDetailLevel: orderedLevels[clampedIndex],
        showMoreDetails: clampedIndex > minIndex ? showMoreDetails : undefined,
        showLessDetails: clampedIndex < maxIndex ? showLessDetails : undefined,
    };
};

export default useDetailLevel;
